'use client';

import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Link from "next/link";

export default class HeroSlider extends React.Component {
    render() {
        const settings = {
            // Define your settings here
            dots: false,
            arrows:false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase:'linear',
            // autoplay:true,
            autoplaySpeed: 5000,
            // variableWidth:true,
            // centerMode:true,
        };
        const data = {
            data: {
                slides: [
                    {
                        image: "/images/heroslider/sound.webp",
                        alt: "Image 1",
                        tag: "Event Production",
                        title:"Audio System Integration",
                        subTitle:'Our people are our best resource. Our high skilled engineer take the time to understand your needs and deliver the best solution for your event',
                        link: "/solutions/sounds",
                    },
                    {
                        image: "/images/heroslider/lighting.webp",
                        alt: "Image 2",
                        tag: "Event Production",
                        title:"Architectural & Theatrical Lighting",
                        subTitle:'Our people are our best resource. Our high skilled engineer take the time to understand your needs and deliver the best solution for your event',
                        link: "/solutions/lighting",
                    },
                    {
                        image: "/images/heroslider/video_blue.webp",
                        alt: "Image 3",
                        tag: "Event Production",
                        title:"Video Conferencing & Projection",
                        subTitle:'Our people are our best resource. Our high skilled engineer take the time to understand your needs and deliver the best solution for your event',
                        link: "/solutions/video",
                    },
                    {
                        image: "/images/heroslider/system_integration.webp",
                        alt: "Image 4",
                        tag: "Event Production",
                        title:"Digital Signage & Control Systems",
                        subTitle:'Our people are our best resource. Our high skilled engineer take the time to understand your needs and deliver the best solution for your event',
                        link: "/solutions/system",
                    },
                    // {
                    //     image: "https://uploads-ssl.webflow.com/5fdacf8c63b6b172b6174351/5fdacf8c63b6b1084b174406_IconAV-Events-Concerts-1.jpg",
                    //     alt: "Image 5",
                    //     tag: "Event Production",
                    //     title:"Room Automation & AV Networking",
                    //     subTitle:'Our people are our best resource. Our high skilled engineer take the time to understand your needs and deliver the best solution for your event',
                    // },
                    //  {
                    //     image: "https://uploads-ssl.webflow.com/5fdacf8c63b6b172b6174351/5fdacf8c63b6b1084b174406_IconAV-Events-Concerts-1.jpg",
                    //     alt: "Image 5",
                    //     tag: "Event Production",
                    //     title:"System Design, Consultation & Support",
                    //     subTitle:'Our people are our best resource. Our high skilled engineer take the time to understand your needs and deliver the best solution for your event',
                    // },

                ],
            }
        };
        return (
           <>
            <Slider {...settings}>
                {data.data.slides.map((slide, index) => (
                    <div className="slide-tab" key={index}>
                        <div className={'image-container'} key={index}>
                            <img src={slide.image} alt={slide.alt} />
                        </div>

                        <div className="description-container">
                            <div className="slide-description">
                                <span className="slide-tag">{slide.tag}</span>
                                <div className="slider-header">
                                    <div className="corner-frame br"></div>
                                    <div className="corner-frame"></div>
                                    <h1 className="slider-title">{slide.title}</h1>
                                </div>
                                <div className="slider-textbox">
                                    <h5 className="slider-subtitle">{slide.subTitle}</h5>
                                    <a href={slide.link} className="slider-link">
                                    
                                    <button className="slider-button">Learn More</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                
            </Slider>
           </>
        );
    }
}